module.exports = "https://cdn.qantashotels.com/qantashotelsui/_next/static/images/qantas-hotels-light-4199e60ac9a2663ce6c0e03c076af9af.svg";